module.exports = __webpack_public_path__ + "static/media/Book-demo-page.fd189850.webp";